<template>
  <v-container
    id="app-cashless-reffil"
    class="pa-1"
  >
    <screen
      :title="$t('field.cashless.solde')"
      :info="$amount(onlineInfos.Solde)"
      :titlesup="captureAmount ? $t('field.cashless.amount_use') : null"
      :infosup="$amount(total)"
      infoclass="green--text"
    />

    <!-- ***** BOUTONS D'ACTION ***** -->
    <div
      v-show="!captureAmount"
      class="pt-3"
    >
      <!-- ****************************************
      ********** CHOIX PAIEMENT CAGNOTTE **********
      ***************************************** -->
      <v-btn
        v-if="buyAmount"
        class="ma-0 half-large"
        @click="useBuyAmount"
      >
        {{ $t('field.cashless.pay', { amount: $amount(buyAmount - offlineSolde) }) }}
      </v-btn>
      <v-btn
        v-else
        class="ma-0 half-large"
        @click="captureAmount = true"
      >
        {{ $t('field.cashless.partial') }}
      </v-btn>

      <v-btn
        class="ma-0 half-large right"
        @click="useFullAmount"
      >
        {{ $t('field.cashless.pay', { amount: $amount(onlineInfos.Solde) }) }}
      </v-btn>

      <v-btn
        class="mt-4 large"
        block
        @click="cancel"
      >
        {{ $t('field.cashless.cancel') }}
      </v-btn>
    </div>

    <!-- ***** SAISIE MONTANT ***** -->
    <keyboard
      v-show="captureAmount"
      v-model="total"
      @del="captureAmount = false"
      @cancel="captureAmount = false"
      @input="pressKey"
      @valid="valid"
    />
  </v-container>
</template>

<script>
import { Scan } from '@/modules/Scan'
import { $alert, $amount } from '@/modules/Utils'
import { ActionEnum } from '@/modules/Enums'

export default {
  name: 'CashlessRefillView',

  props: {
    offlineInfos : { type: Object, default: null },
    offlineSolde : { type: [String, Number], default: null },
    onlineInfos: { type: Object, default: null },
  },

  data () {
    return {
      captureAmount: false,
      total: 0,
    }
  },

  computed: {
    buyAmount () { return this.$store.state.amount }
  },

  beforeMount () {
    this.$emit('title', this.$i18n.t('title.cashlessRefill'))
  },

  methods: {
    $amount,
    useBuyAmount () {
      this.total = this.buyAmount - this.offlineSolde
      this.valid()
    },
    useFullAmount () {
      this.total = this.onlineInfos.Solde
      this.valid()
    },
    pressKey () {
      if (this.total > this.onlineInfos.Solde) {
        this.total = this.onlineInfos.Solde
      }
    },
    cancel () {
      if (this.offlineInfos) {
        this.$router.replace({
          name: 'info-badge-offline',
          params: { infos: this.offlineInfos }
        })
      } else {
        this.$router.replace('/home')
      }
    },
    valid () {
      // Débit du PME online
      Scan.launchDebit(
        this.onlineInfos.IDBadge,
        'P',
        '',
        this.onlineInfos.Solde,
        () => {
          this.$router.replace({
            name: 'scan-nfc-offline',
            params: {refillAmount: this.total, idBadge: this.onlineInfos.IDBadge, action: ActionEnum.cashlessRefill , mode: 'X'}
          })
        },
        (error) => {
          $alert(error)
        },
        true, // permet le retour successCallback
        null,
        this.total
      )
    }
  }
}
</script>
